import React from 'react';
import { accessRole } from '../../../helpers/access_role';
import ErrorAccess from '../../../components/Error/Content/Access';
import IndexView from './Index/View';
import DetailView from './Detail/View';

const RouteView = (props) => {
  const queryParams = new URLSearchParams(props.location?.search || window.location.search);
  const _detail = queryParams.get('detail');

  // Check if role-based access is active in current session
  const hasAccessConfig = sessionStorage.getItem('accessPath') !== null;
  const isAllowed = !hasAccessConfig || accessRole('read');

  if (!isAllowed) {
    return <ErrorAccess />;
  }

  if (_detail !== null) {
    return <DetailView />;
  }

  return <IndexView />;
};

export default RouteView;
